import React from "react";
import { Modal, Form, Input, Button, Spin, Steps } from "antd";
import moment from "moment";
import { formatAmount, sub, dateFormat, formatSeconds } from "$ACTIONS/util";
import { Cookie } from "$ACTIONS/helper";
import { put } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { pwdReg } from "$ACTIONS/reg";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import Router from "next/router";
const { Item } = Form;
const { Step } = Steps;
class PassWordVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            userPassWord: "",
            confirmUserPwd: "",
            userPassWordError: true,
            confirmUserPwdError: true,
            btnStatus: true,
            remainingTime: "10:00",
            verificationTimedOut: false, //提示过期 modal
            pwdType1: "password",
            pwdType2: "password",
            iconName1: "close",
            iconName2: "close",
            firstModal: true,
        };
        this.timeTimer = null; // 倒计时Timer
        this.startCountDown = this.startCountDown.bind(this); // 倒计时
    }
    componentDidMount() {
        Cookie.Create("pwdTime", dateFormat(), { expires: 10 });
        this.startCountDown();
    }
    componentWillUnmount() {
        Cookie.Create("pwdTime", null);
        clearInterval(this.timeTimer);
    }
    startCountDown() {
        this.setState({ remainingTime: "10:00" });
        clearInterval(this.timeTimer);
        const pwdTime = Cookie.Get("pwdTime")
            .replace("-", "/")
            .replace("-", "/");
        let lastSeconds = parseInt(
            600 - (new Date().getTime() - new Date(pwdTime).getTime()) / 1000
        );
        this.timeTimer = setInterval(() => {
            if (lastSeconds <= 0) {
                Cookie.Create("pwdTime", null);
                clearInterval(this.timeTimer);
                this.setState({
                    verificationTimedOut: true,
                    firstModal: false,
                });
            } else {
                this.setState({ remainingTime: formatSeconds(lastSeconds--) });
            }
        }, 1000);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const MemberData = {
            newPassword: this.state.userPassWord,
        };
        this.setState({ isLoading: true });
        put(ApiPort.SetChangePassword, MemberData)
            .then((res) => {
                this.setState({ isLoading: false });
                if (res.isSuccess == true) {
                    this.setState({
                        apiError: undefined,
                    });
                    global.showResultModal("密码更新成功", true, 1501, "otp");
                    Cookie.Create("pwdTime", null);
                    setTimeout(() => {
                        this.setState({ firstModal: false });

                        localStorage.setItem("login-otpPwd", true); // 驗證成功
                        Router.push("/cn/");
                    }, 3500);
                } else {
                    if (res.errors) {
                        this.setState({
                            apiError: res.errors[0].description,
                        });
                    }
                }
            })
            .catch((error) => {
                console.log("updatePassword error:", error);
            });
    };
    changePassword = (e, v) => {
        if (v === "pwd") {
            this.setState({ userPassWord: e.target.value });
            if (pwdReg.test(e.target.value) == false) {
                this.setState({
                    userPassWordError: false,
                    btnStatus: true,
                });
            } else {
                this.setState(
                    {
                        userPassWordError: true,
                    },
                    () => {
                        if (
                            this.state.userPassWord ===
                            this.state.confirmUserPwd
                        ) {
                            this.setState({ btnStatus: false });
                        }
                    }
                );
            }
        }

        if (v === "confirmpwd") {
            this.setState({ confirmUserPwd: e.target.value });
            if (this.state.userPassWord !== e.target.value) {
                this.setState({
                    confirmUserPwdError: false,
                    btnStatus: true,
                });
            } else {
                this.setState(
                    {
                        confirmUserPwdError: true,
                    },
                    () => {
                        if (
                            this.state.userPassWord ===
                            this.state.confirmUserPwd
                        ) {
                            this.setState({ btnStatus: false });
                        }
                    }
                );
            }
        }
    };
    closeModal = () => {
        this.setState({ verificationTimedOut: false });
        Cookie.Create("pwdTime", null);
        global.globalExit();
    };
    onChangePwd(value) {
        if (value === "1") {
            if (this.state.pwdType1 === "password") {
                this.setState({ pwdType1: "text", iconName1: "open" });
            } else {
                this.setState({ pwdType1: "password", iconName1: "close" });
            }
        }
        if (value === "2") {
            if (this.state.pwdType2 === "password") {
                this.setState({ pwdType2: "text", iconName2: "open" });
            } else {
                this.setState({ pwdType2: "password", iconName2: "close" });
            }
        }
    }
    render() {
        const {
            confirmUserPwdError,
            userPassWordError,
            btnStatus,
            remainingTime,
            verificationTimedOut,
            pwdType1,
            pwdType2,
            firstModal,
            iconName1,
            iconName2,
            apiError,
        } = this.state;
        return (
            <React.Fragment>
                {firstModal && (
                    <Modal
                        title={`更换密码`}
                        className="SecurityAnnouncement modal-pubilc OTP-modal"
                        visible={this.props.otpPwdVisible}
                        closable={false}
                        centered={true}
                        width={400}
                        footer={null}
                        zIndex={1500}
                    >
                        <Spin spinning={this.state.isLoading}>
                            <div className="StepsBox SecuritySteps">
                                <Steps current={1} size="small">
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>

                            <Form
                                className="verification-form-wrap"
                                {...formItemLayout}
                                onSubmit={this.handleSubmit}
                            >
                                <div className="line-distance" />
                                <div className="text-tip TextLightYellow">
                                    您还有 {remainingTime} 分钟来更新新密码。
                                    请在时间结束前更改密码。
                                    {/* <span onClick={() => this.props.VerifyCategory('CS')}>在线客服</span>。 */}
                                </div>
                                <div className="line-distance" />
                                <Item label="新密码">
                                    <Input
                                        size="large"
                                        placeholder="请输入 6 - 20 位密码"
                                        className="tlc-input-disabled"
                                        autoComplete="off"
                                        onChange={(e) =>
                                            this.changePassword(e, "pwd")
                                        }
                                        type={pwdType1}
                                        suffix={
                                            <img
                                                className={`icon-${pwdType1}-eyes`}
                                                src={`/cn/img/user/otpVerify/icon-${iconName1}-eyes.png`}
                                                alt=""
                                                onClick={() =>
                                                    this.onChangePwd("1")
                                                }
                                            />
                                        }
                                    />
                                    {!userPassWordError && (
                                        <p className="error-tip TextLightRed">
                                            密码必须包含6-20个字符，字符只限于使用字母和数字，至少包含这四个符号（^#$@）其中一个
                                        </p>
                                    )}
                                </Item>
                                {apiError && (
                                    <p className="error-tip TextLightRed">
                                        {apiError}
                                    </p>
                                )}
                                <Item label="确认新密码">
                                    <Input
                                        size="large"
                                        placeholder="再次输入密码确认"
                                        className="tlc-input-disabled"
                                        autoComplete="off"
                                        onChange={(e) =>
                                            this.changePassword(e, "confirmpwd")
                                        }
                                        type={pwdType2}
                                        suffix={
                                            <img
                                                className={`icon-${pwdType2}-eyes`}
                                                src={`/cn/img/user/otpVerify/icon-${iconName2}-eyes.png`}
                                                onClick={() =>
                                                    this.onChangePwd("2")
                                                }
                                            />
                                        }
                                    />
                                </Item>
                                {!confirmUserPwdError && (
                                    <p className="error-tip TextLightRed">
                                        密码不一致
                                    </p>
                                )}
                                <Item {...tailFormItemLayout}>
                                    <div className="btn-wrap">
                                        <Button
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                            block
                                            disabled={btnStatus}
                                        >
                                            更新
                                        </Button>
                                    </div>
                                </Item>
                                {/* <div className="timeTip">请在 {remainingTime} 前完成密码更新。</div> */}
                            </Form>
                        </Spin>
                    </Modal>
                )}

                <Modal
                    title={`等待超时`}
                    className="modal-pubilc OTP-modal "
                    visible={verificationTimedOut}
                    closable={false}
                    centered={true}
                    width={400}
                    footer={null}
                    zIndex={1500}
                >
                    <Spin spinning={this.state.isLoading}>
                        <Form
                            className="verification-form-wrap"
                            {...formItemLayout}
                            onSubmit={this.closeModal}
                        >
                            <div className="line-distance" />
                            <div className={`otpPwdModal-Item`}>
                                {/* <i>
									<img src="/cn/img/user/otpVerify/icon-warn.png" />
								</i> */}
                                {/* <p className="text1">该次登录已经超时</p> */}
                                <p className="text2">
                                    您该次登录已经超时，请再次登录以验证并更新密码。
                                </p>
                            </div>
                            <Item {...tailFormItemLayout}>
                                <div className="btn-wrap">
                                    <Button
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                        block
                                    >
                                        重新登录
                                    </Button>
                                </div>
                            </Item>
                        </Form>
                    </Spin>
                </Modal>
            </React.Fragment>
        );
    }
}

export default PassWordVerify;
